import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveButtonComponent } from './save-button/save-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TrabajadorAutocompleteComponent } from './autocomplete/trabajador-autocomplete.component';
import {SharedModule} from "../shared.module";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MaterialModule} from "../material.module";
import {ReactiveFormsModule} from "@angular/forms";
import { LoadingOverlayComponent } from './ui/loading-overlay/loading-overlay.component';
import { FallaModalComponent } from './falla/falla-modal.component';
import { MatDialogModule } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";

@NgModule({
  declarations: [
    SaveButtonComponent,
    TrabajadorAutocompleteComponent,
    LoadingOverlayComponent,
    FallaModalComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MaterialModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule
  ],
  exports: [
    SaveButtonComponent,
    TrabajadorAutocompleteComponent,
    LoadingOverlayComponent,
    FallaModalComponent
  ]
})
export class ComponentsModule { }
